const computeHighlights = require('./compute-highlights');

module.exports = {
    computeHighlights
};
